import { createListenerMiddleware } from '@reduxjs/toolkit';

import { dragEnd } from '../../lib/redux/campaignDnd/campaignDndSlice';
import { dragEndEffect } from './campaignDnd/campaignDndEffects';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: dragEnd,
  effect: dragEndEffect,
});
